import {useHistory} from "react-router-dom";
import ResultText from "./ResultText";
import ResultTable from "../Table/ResultTable";
import ResultRow from "../Table/ResultRow";
import ResultBodyCell from "../Table/ResultBodyCell";
import {Table} from "antd";
import {useEffect} from "react";
import EmptyLine from "../EmptyLine";

export default function OutputError({error}) {
    const history = useHistory();

    useEffect(() => {
        console.log(error)
    }, [error])

    if(error.error_id === 'NO-OUT-01') {
        return (
            <ResultText>
                <table>
                    <tr>
                        <td>
                            <img src={'/icons/warning.png'} width={16} alt={'warning'}/>
                        </td>
                        <td>
                            This check could not be completed because the output text file is missing. Please prepare and include the output text file as directed in
                            <a onClick={() => {history.push('/app/help?type=output')}}>{' '}How to menu.</a>
                        </td>
                    </tr>
                </table>
            </ResultText>
        )
    }
    else if(error.error_id === 'NO-OUT-02') {
        return (
            <ResultText>
                <table>
                    <tr>
                        <td>
                            <img src={'/icons/warning.png'} width={16} alt={'warning'}/>
                        </td>
                        <td>
                            The following variables are missing in the output file. Please prepare and include the output text file as directed in
                            <a onClick={() => {history.push('/app/help?type=output')}}>{' '}How to menu.</a>
                            <EmptyLine />
                            {error?.data?.map(x => x?.col_name).join(', ')}
                            <EmptyLine />
                        </td>
                    </tr>
                </table>
            </ResultText>
        )
    }


}